
<script setup>

</script>

<template>
  <div class="cmp-grid-function-tips_wrapper">
    <div style="font-size: 14px; font-weight: bold">Grid Functionality</div>
    <span style="font-size: 11px;">(If the grid menu is disabled, any configuration of the columns will not be saved)</span>
    <ul>
      <li>
        If enabled, use the menu to disable / enable columns.
      </li>
      <li>
        Drag columns from the heading to re-order them.
      </li>
      <li>
        Resize columns by clicking on the right hand side of data headings and pull the marker to the desired position
        (The position of columns will only be saved on configurable grids).
      </li>
      <li>
        Right click on data cells to copy the value to clipboard.
      </li>
      <li>
        Left click highlights the current row to spotlight the record for added focus.
      </li>
      <li>
        Clicking the small up / down arrows within the headings will sort data by that column ascending / descending.
      </li>
    </ul>
  </div>

</template>

<style lang="scss" scoped>

ul li {
  margin-bottom: 4px;
}

.cmp-grid-function-tips {

  &_wrapper {
    height: 180px;
    width: 500px;
    padding: 10px;
  }
}

</style>
